<form #form="ngForm"
      method="POST"
      class="block form-small">
    @for (giftcard of basket.data.giftcards | values; track trackByGiftcard($index, giftcard)) {
    <div class="m-t-1 p1">
        <giftcards-added-giftcard [giftcard]="giftcard"></giftcards-added-giftcard>
    </div>
    }
    <div class="w-12 m-t-2-s bg-col-51"
         zippyName="gift">
        <div class="w-12 pos-relative">

            <!-- 'offer' tab header -->
            <div class="cursor-pointer flex flex-middle flex-justify-between p-a-2"
                 [zippyToggle]="['gift','offer']"
                 zippyClass="is-open">
                <span class="p2">{{'Have you got a gift card?' | translate}}</span>
                <i aria-hidden="true"
                   class="icon-plus-animate fs-4 m-r-1"></i>
            </div>
            <div class="ng-hide-animate"
                 [zippyHideUp]="['gift','offer']"
                 zippyAnimationDuration="350">
                <div class="form-small p-a-2 p-b-10">
                    <input-wrap class="no-validation-icon">
                        <input class="input bg-col-5"
                               type="text"
                               name="giftcard"
                               required
                               (keydown.enter)="submit()"
                               [(ngModel)]="data.code"
                               [muiInput]="'Enter a gift card' | translate">
                    </input-wrap>
                    <div class="m-t pos-relative">
                        <div class="c-12-set m-r-0 m-b-2">
                            <div class="w-6 p-r-1">
                                <action class="w-12 button"
                                        (click)="submit()"
                                        [status]="status">
                                    <span>{{'Apply' | translate}}</span>
                                </action>
                            </div>
                            <div class="w-6 p-l-1">
                                <action class="w-12 button-1"
                                        (click)="checkBalance()"
                                        [status]="balanceStatus">
                                    <span>{{'Check balance' | translate}}</span>
                                </action>
                            </div>
                        </div>
                        @if (hasBalance) {
                        <p class="p1 col-12 m-t-2 center">{{'Your balance is' | translate}}&nbsp;
                            <price [value]="balance"
                                   [precision]="2"></price>
                        </p>
                        }
                        <result class="pos-absolute left-0 top-100 col-2 c1 m-t--1"
                                [status]="status"></result>
                        <result class="pos-absolute left-0 top-100 col-2 c1 m-t--1"
                                [status]="balanceStatus"></result>
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>
